import { render } from "./PushMessage.vue?vue&type=template&id=d1197faa&scoped=true"
import script from "./PushMessage.vue?vue&type=script&lang=js"
export * from "./PushMessage.vue?vue&type=script&lang=js"

import "./PushMessage.vue?vue&type=style&index=0&id=d1197faa&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1197faa"]])

export default __exports__